import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetLeaves, CreateLeave, DeleteLeave } from "../Api";
import { DEFAULT_STALE_TIME, ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";

export const leaveQueryKeys = {
  leaves: (params?: Parameters<typeof GetLeaves>[0]) => ["leaves", params] as const,
};

export const useLeavesQuery = (
  params?: Parameters<typeof GetLeaves>[0],
  options?: ServiceQueryOptions
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: leaveQueryKeys.leaves(params),
    queryFn: async () => unwrapApiResponse(await GetLeaves(params)),
  });
};

export const useCreateLeaveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateLeave>[0]) => CreateLeave(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: ["leaves"] });
      }
    },
  });
};

export const useDeleteLeaveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => DeleteLeave(id),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: ["leaves"] });
      }
    },
  });
};
